import keyMirror from 'fbjs/lib/keyMirror';

export default keyMirror({
  SPINNER_START: null,
  SPINNER_STOP: null,

  STEP_SET_UPLOAD_DATA: null,
  STEP_SET_HEIGHT: null,
  STEP_SET_UPLOAD_ID: null,

  STEP_UPLOAD: null,
  STEP_CONVERT: null,
  STEP_DOWNLOAD: null,

  GALLERY_GET_LAST: null,
  GALLERY_GET_MORE: null
});



/** WEBPACK FOOTER **
 ** ./src/constants/ActionTypes.js
 **/